<template>
    <el-drawer :modal="false" 
        :visible.sync="callLogDrawer"
        title="Esther's Call Log"
        class="drawer-call-log"
        size="45%"
    >
        <b-container>
            <b-row>
                <b-col cols="4">
                    <b-form-group class="mb-0">
                        <el-date-picker
                            v-model="filters.date"
                            type="date"
                            placeholder="Filter by date"
                        >
                        </el-date-picker>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group class="mb-0">
                        <el-select v-model="filters.status" placeholder="Filter by Call Status">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="table-listings">
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    style="width: 100%"
                    class="mt-4"
                >
                    <el-table-column
                        label="Call type"
                        min-width="130"
                        prop="call_type"
                    >
                        <template slot-scope="scope">
                            <p class="top-line">
                                <b-icon icon="telephone-outbound-fill"></b-icon>  
                                {{ scope.row.call_type }}
                            </p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="Caller"
                        min-width="100"
                        prop="caller"
                        sortable
                    >
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.caller }}</p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="Call Status"
                        min-width="150"
                        prop="call_status"
                        sortable
                    >
                        <template slot-scope="scope">
                            <p class="top-line" :class="generateStatusColor(scope.row.call_status)">{{ scope.row.call_status }}</p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="Duration"
                        min-width="120"
                        prop="call_duration"
                        sortable
                    >
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.call_duration }}</p>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="Date & Time"
                        min-width="180"
                        prop="call_date_time"
                        sortable
                    >
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.call_date_time }}</p>
                        </template>
                    </el-table-column>
                        
                </el-table> 
            </div>
        </b-container>

    </el-drawer>
</template>
<script>
import { Drawer, Option, Select, Table, TableColumn, DatePicker } from 'element-ui'

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Drawer.name]: Drawer,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            callLogDrawer: false,
            filters: {
                date: '',
                status: '',
            },
            key:{
                messaging_documents: 1
            },
            tableData: [
                {
                    call_type: 'Outbound',
                    caller: 'Zaful',
                    call_status: 'Completed',
                    call_duration: '12:08',
                    call_date_time: 'Today, 2:00pm'
                },
                {
                    call_type: 'Outbound',
                    caller: 'Trini S.',
                    call_status: 'Completed',
                    call_duration: '24:12',
                    call_date_time: '22 Nov 2022, 4:30pm'
                },
                {
                    call_type: 'Outbound',
                    caller: 'Trini S.',
                    call_status: 'Missed Call',
                    call_duration: '-',
                    call_date_time: '22 Nov 2022, 1:00pm'
                },
            ],
            options: [

            ],
        }
    },
    methods: {
        viewCallLogDrawer() {
            this.callLogDrawer = !this.callLogDrawer
        },
        generateStatusColor(status) {
            switch (status) {
                case 'Completed':
                    return 'text-success'
                    break;
                case 'Missed Call':
                    return 'text-danger'
                    break;
                default:
                    break;
            }
        }
    }
}
</script>